export default function CarrierCommissionManagement() {

  return (
      <p>مدیریت کمیسیون</p>
  );
};